import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZApiResponse = z.object({
  http_status: z.number(),
  data: z.array(z.string()).nullable(),
  error: z.boolean()
})

export async function getAllTenants (
  onSuccess: (assetTypes: string[], httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = '/app-config-service/api/v1/crypto/hsm-regular-keks/types'

  interceptedAxios
    .get(url)
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      if (parseResponse.success) {
        if (
          parseResponse.data.data !== null &&
                    parseResponse.data.data !== undefined
        ) {
          onSuccess(parseResponse.data.data, response.status)
        } else {
          onFailure([], response.status)
        }
      } else {
        onFailure('Unable to parse Response', response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(error.response.data.error_message, error.response.status)
      } else {
        onFailure('Network Error', 500)
      }
    })
}
